import React from 'react';
import MuiDrawer from '@mui/material/Drawer';
export const Drawer = ({ anchor = 'right', children, _sx, open = false, elevation = 0, onClose, PaperProps, variant = 'temporary', className = '', dataTestId, ModalProps, }) => {
    return (React.createElement(MuiDrawer, { className: className, variant: variant, elevation: elevation, anchor: anchor, open: open, onClose: onClose, sx: _sx, PaperProps: PaperProps, "data-testid": dataTestId, ModalProps: ModalProps }, children));
};
